export default "__VITE_ASSET__Wy7tpoNp__"